/** Structured brand brief on a marketplace order (stored on `marketplaceOrders`). */
export interface MarketplaceOrderBrief {
  projectName?: string;
  narrative?: string;
  logistics?: {
    fulfillmentType: string;
    contentDeliveryTargetDate?: string;
  };
}

export function isOrderBriefProvided(b: MarketplaceOrderBrief | undefined): boolean {
  if (!b || typeof b !== 'object') return false;
  if (b.projectName?.trim()) return true;
  if (b.narrative?.trim()) return true;
  const log = b.logistics;
  if (log?.fulfillmentType?.trim()) return true;
  if (log?.contentDeliveryTargetDate?.trim()) return true;
  return false;
}

